import { ISignStrategyFactory } from './isign-strategy.factory';
import { CloudKeyReaderType, CloudProvider, DepositSignAuthType } from '@/sign/models/sign-constants';
import { ISignStrategy } from '@/sign/strategies/isign.strategy';
import { appSettingsHelper } from '@/helpers/settings-helper';

type SignStrategyConstructor = new (...args: any[]) => ISignStrategy;

export class SignStrategyFactory implements ISignStrategyFactory {
  FileConstructor: SignStrategyConstructor;
  DeviceConstructor: SignStrategyConstructor;
  DepositSignLoginPswConstructor: SignStrategyConstructor;
  DiiaConstructor: SignStrategyConstructor;
  CloudKeyFileSystemConstructor: SignStrategyConstructor;
  SigningWithQrCloudProvider: SignStrategyConstructor;
  SigningWithIdCloudProvider: SignStrategyConstructor;

  constructor(
    FileConstructor: SignStrategyConstructor,
    DeviceConstructor: SignStrategyConstructor,
    DepositSignLoginPswConstructor: SignStrategyConstructor,
    DiiaConstructor: SignStrategyConstructor,
    CloudKeyFileSystemConstructor: SignStrategyConstructor,
    SigningWithQrCloudProvider: SignStrategyConstructor,
    SigningWithIdCloudProvider: SignStrategyConstructor
  ) {
    this.FileConstructor = FileConstructor;
    this.DeviceConstructor = DeviceConstructor;
    this.DepositSignLoginPswConstructor = DepositSignLoginPswConstructor;
    this.DiiaConstructor = DiiaConstructor;
    this.CloudKeyFileSystemConstructor = CloudKeyFileSystemConstructor;
    this.SigningWithQrCloudProvider = SigningWithQrCloudProvider;
    this.SigningWithIdCloudProvider = SigningWithIdCloudProvider;
  }

  createSignFileSystemStrategy(prms?: any): ISignStrategy {
    return new this.FileConstructor(prms);
  }

  createSignDeviceStrategy(prms?: any): ISignStrategy {
    return new this.DeviceConstructor(prms);
  }

  createSignCloudStrategy(signProvider: string, keyReaderType: string, prms?: any): ISignStrategy {
    let strategy: ISignStrategy;

    if (signProvider === CloudProvider.DepositSign &&
        keyReaderType === DepositSignAuthType.LoginPassword) {
      strategy = new this.DepositSignLoginPswConstructor(prms);
    } else if (signProvider === CloudProvider.DPDiya) {
      strategy = new this.DiiaConstructor(prms);
    } else if (signProvider === CloudProvider.CloudKey &&
               keyReaderType === CloudKeyReaderType.FileSystem) {
      strategy = new this.CloudKeyFileSystemConstructor(prms);
    } else {
      const cloudProviderSettings = appSettingsHelper.iitCloudProviderSettings
        .find(s => s.id === signProvider);

      if (!cloudProviderSettings) {
        throw new Error(`Cloud provider "${signProvider}" settings not found.`);
      }

      const extParams = Object.assign(prms, { mobileAppName: cloudProviderSettings.mobileAppName });
      if (cloudProviderSettings.isSigningWithQr) {
        strategy = new this.SigningWithQrCloudProvider(extParams);
      } else {
        strategy = new this.SigningWithIdCloudProvider(extParams);
      }
    }

    return strategy;
  }
}
